var render = function render(){var _vm=this,_c=_vm._self._c;return _c('center',{staticClass:"mt-4"},[_c('h1',[_vm._v("Suzuya Products")])])
}
var staticRenderFns = []

export { render, staticRenderFns }